<img [src]="imagePath()" alt="" />
